<img [src]="imagePath()" alt="" />
